import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EmailSent.css';

interface LocationState {
  email: string;
  isNewAccount?: boolean;
  fromSignup?: boolean;
  emailSendFailed?: boolean;
}

const EmailSent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const email = state?.email || 'your email address';
  const isNewAccount = state?.isNewAccount;
  const fromSignup = state?.fromSignup;
  const emailSendFailed = state?.emailSendFailed;

  return (
    <div className="email-sent-container">
      <div className="email-sent-card">
        <div className="email-sent-icon">✉️</div>
        <h1>{isNewAccount ? 'Account Created!' : 'Verification Email Sent!'}</h1>
        
        <div className="email-sent-content">
          {emailSendFailed ? (
            <div className="error" style={{ marginBottom: '1rem' }}>
              <strong>There was a problem sending the verification email.</strong>
              <br />
              Please log in and use the "Resend Verification Email" option, or contact support.
            </div>
          ) : (
            <p className="email-destination">
              We've sent a verification email to:
              <br />
              <strong>{email}</strong>
            </p>
          )}

          <div className="instructions-box">
            <h2>Next Steps:</h2>
            <ol>
              <li>
                <span className="step-number">1</span>
                <span className="step-text">
                  Check your email inbox
                  <small>(Don't forget to check your spam folder)</small>
                </span>
              </li>
              <li>
                <span className="step-number">2</span>
                <span className="step-text">
                  Click the verification link in the email
                </span>
              </li>
              <li>
                <span className="step-number">3</span>
                <span className="step-text">
                  {isNewAccount 
                    ? 'Return here to continue with your registration'
                    : 'Return here to continue'}
                </span>
              </li>
            </ol>
          </div>

          {isNewAccount && (
            <div className="welcome-message">
              <h3>Welcome to Berwick Camp!</h3>
              <p>
                We're excited to have you join our community. Once you verify your email,
                you'll be able to complete your registration for this year's camp.
              </p>
            </div>
          )}

          <div className="action-buttons">
            <button 
              className="secondary-button"
              onClick={() => navigate('/login', { state: { fromSignup } })}
            >
              Back to Login
            </button>
          </div>

          <div className="help-box">
            <h3>Having Trouble?</h3>
            <p>
              If you don't receive the email within a few minutes:
            </p>
            <ul>
              <li>Check your spam/junk folder</li>
              <li>Verify you entered the correct email address</li>
              <li>Contact support if you need assistance</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSent; 